import categoryReducer from './categoryReducer';

export * from './categoryActions';
export default categoryReducer;
